import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import Cap from './Cap';


ReactDOM.render(<App/>,document.getElementById('root'))
    



